import { render, staticRenderFns } from "./FmxHeroWithButtons.vue?vue&type=template&id=d64c8ece&"
import script from "./FmxHeroWithButtons.vue?vue&type=script&lang=js&"
export * from "./FmxHeroWithButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports